export const hasPermission = (user, moduleName) => {
  if (!user) return false;
  
  // Owner (role 'users' or undefined/null role usually treated as owner) has full access
  if (user.role !== 'subuser') return true;
  
  // If permissions array exists, it MUST be respected, even for admins
  if (user.permissions && Array.isArray(user.permissions) && user.permissions.length > 0) {
    const permission = user.permissions.find(p => p.module === moduleName);
    return !!(permission && permission.can_view);
  }
  
  // Fallback: only if NO permissions array exists, allow admin full access
  if (user.access_profile === 'admin') return true;
  
  return false;
};
